{% block sw_theme_list_item %}
<div class="sw-theme-list-item" :class="componentClasses">

    {% block sw_theme_list_item_options %}
    <slot name="contextMenu"></slot>
    {% endblock %}

    {% block sw_theme_list_item_image %}
    <div
        v-if="theme"
        class="sw-theme-list-item__image"
        :style="previewMedia"
        @click="emitItemClick(theme)"
    >
    </div>

    <div v-else class="sw-theme-list-item__image is--empty">
        {{ $t('sw-theme-manager.themeListItem.emptyText') }}
    </div>
    {% endblock %}

    {% block sw_theme_list_item_info %}
    <div class="sw-theme-list-item__info">
        <div
            v-if="theme"
            class="sw-theme-list-item__status"
            :class="componentClasses"
        ></div>
        <div
            v-if="theme"
            class="sw-theme-list-item__title"
            @click="onThemeClick"
        >{{ theme.name }}</div>
        <mt-icon
            v-if="theme && theme.technicalName"
            v-tooltip="lockToolTip"
            class="sw-theme-list-item__locked"
            name="regular-lock"
            size="16"
        />
    </div>
    {% endblock %}
</div>
{% endblock %}
